export const USER_RETENTION_IMAGE_PATHS = {
  BEFORE: "2/gen/before.png",
  AFTER: "2/gen/after.png"
} as const;

export const USER_RETENTION_CHANGES = [
  "Ribbon color changed",
  "Freckles removed",
  "Background removed",
  "Text changed"
] as const;

export const USER_RETENTION_CHANGES_MOBILE = [
  "Ribbon changed",
  "Freckles removed",
  "Background removed",
  "Text changed"
] as const;

export const USER_RETENTION_MODAL_SHOWN_KEY = "IS_DTF_USER_RETENTION_MODAL_SHOWN";

export const INACTIVITY_INTERVAL_MS = 20000;
export const INACTIVITY_MAX_CALL_COUNT = 1;

export const MODAL_TRIGGER_POINTS = {
  INACTIVITY: "inactivity",
  EXIT_INTENT: "exit_intent",
  NONE: "none"
} as const;

export type ModalTriggerPoint = (typeof MODAL_TRIGGER_POINTS)[keyof typeof MODAL_TRIGGER_POINTS];
